module.exports = __webpack_public_path__ + "static/media/06-magazine2.c1155d66.png";